package one.healthium.pilates

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.platform.LocalFontFamilyResolver
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.platform.Font
import androidx.compose.ui.window.ComposeViewport
import co.touchlab.kermit.Logger
import com.arkivanov.decompose.DefaultComponentContext
import com.arkivanov.decompose.ExperimentalDecomposeApi
import com.arkivanov.decompose.router.webhistory.withWebHistory
import com.arkivanov.essenty.lifecycle.LifecycleRegistry
import com.arkivanov.essenty.lifecycle.resume
import com.arkivanov.essenty.lifecycle.stop
import one.healthium.pilates.presentation.navigation.root.DefaultRootComponent
import one.primehealth.app.detectFlavour
import one.primehealth.app.loadResource
import one.primehealth.app.processDeepLink
import org.jetbrains.skiko.wasm.onWasmReady
import web.dom.DocumentVisibilityState
import web.dom.document
import web.dom.visible

@OptIn(ExperimentalComposeUiApi::class, ExperimentalDecomposeApi::class)
fun main() {
    val flavour = detectFlavour(BuildKonfig.BUILD_FLAVOUR)

    AppInit.init(flavour)

    val lifecycle = LifecycleRegistry()

    lifecycle.attachToDocument()

    onWasmReady {
        ComposeViewport(viewportContainerId = "ComposeTarget") {
            val fontFamilyResolver = LocalFontFamilyResolver.current

            ComposeApp { params ->
                val notoFont = loadResource("./NotoColorEmojiV2.ttf") ?: ByteArray(0)
                val fontFamily = FontFamily(listOf(Font("NotoColorEmoji", notoFont)))
                fontFamilyResolver.preload(fontFamily)

                withWebHistory { stateKeeper, deepLink ->
                    Logger.d("nav deepLink: $deepLink, ${deepLink?.processDeepLink()}")
                    DefaultRootComponent(
                        componentContext = DefaultComponentContext(lifecycle = lifecycle, stateKeeper = stateKeeper),
                        params = params,
                        initialDeepLink = { deepLink?.processDeepLink() },
                    )
                }
            }
        }
    }
}

private fun LifecycleRegistry.attachToDocument() {
    fun onVisibilityChanged() {
        if (document.visibilityState == DocumentVisibilityState.visible) {
            resume()
        } else {
            stop()
        }
    }

    onVisibilityChanged()
}
